import "./AccountSettings.scss"
import moment from "moment";
import {Link} from "react-router-dom";
import editIcon from "../../../assets/images/icons/edit2.svg";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";

const AccountSettings = () => {

    const {profile} = useAppSelector(state => state.profileSlice);
    const {t} = useTranslation();


    return (
        <div className="container">
            {
                profile && <section className="account-settings-section">
                    <div className="card">
                        <h3 className="title">{t("PersonalInformation")}
                            <Link className="card-link" to={"edit"}>
                                <img src={editIcon} alt={"edit"}/>
                                {t("Edit")}
                            </Link>
                        </h3>
                        <div className="card-wrapper">
                            <div className="card-item">
                                <h4 className="card-item__title">
                                    {t("Email")}
                                </h4>
                                <p className="card-item__info">
                                    {profile.email}
                                </p>
                            </div>

                            <div className="card-item">
                                <h4 className="card-item__title">
                                    {t("Phone")}
                                </h4>
                                <p className="card-item__info">
                                    {profile.phone}
                                </p>
                            </div>

                            <div className="card-item">
                                <h4 className="card-item__title">
                                    {t("DateOfBirth")}
                                </h4>
                                <p className="card-item__info">
                                    {moment(profile.dateOfBirth).format("DD/MM/YYYY")}
                                </p>
                            </div>

                            <div className="card-item">
                                <h4 className="card-item__title">
                                    {t("Joined")}
                                </h4>
                                <p className="card-item__info">
                                    {moment(profile.createdAt).format("DD MMM YYYY")}
                                </p>
                            </div>
                        </div>

                    </div>
                </section>
            }
        </div>
    )
}

export default AccountSettings;